import * as Sentry from "@sentry/react";
import { StandardErrorDisplay } from "./StandardErrorDisplay";

interface SentryErrorFallbackProps {
  error: unknown;
  componentStack: string;
  eventId: string;
  resetError: () => void;
}

function SentryErrorFallback({ error, resetError }: SentryErrorFallbackProps) {
  return (
    <StandardErrorDisplay 
      error={error} 
      resetError={resetError}
    />
  );
}

interface SentryErrorBoundaryProps {
  children: React.ReactNode;
}

export function SentryErrorBoundary({ children }: SentryErrorBoundaryProps) {
  return (
    <Sentry.ErrorBoundary
      fallback={SentryErrorFallback}
      showDialog
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}